import template from './BuilderQueues.html';
import { BuilderQueuesController } from './BuilderQueuesController';
export const BuilderQueuesComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: BuilderQueuesController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        application: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        elementId: '@?',
        changeMode: '&?',
        queueName: '@?',
        queueId: '@?',
    },
};
